import { Layers } from "appworks/graphics/layers/layers";
import { Model } from "appworks/model/model";
import { Autoplay } from "slotworks/services/autoplay/autoplay";

export class GamevyAutoplay extends Autoplay {

    public stop() {
        if (Layers.get("Speed")?.hasScene("default")) {
            const quickSpin = false;
            const turboSpin = false;
            Model.write({ settings: { quickSpin, turboSpin } });
        }

        super.stop();
    }
}
